import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × MAISON MARGIELA: Deconstruction logic
// Ghost grids, white-on-white, visible seams
export function VasarelyMargielaMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Pure white background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.white} />

      <g transform="translate(397 540)">
        {/* Ghost grid (transparency) */}
        {Array.from({ length: 22 }).map((_, i) =>
          Array.from({ length: 28 }).map((_, j) => {
            const x = (i - 10.5) * 32;
            const y = (j - 13.5) * 30;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 14}
                y={y - 13}
                width="28"
                height="26"
                fill="none"
                stroke="#E8E8E8"
                strokeWidth="1"
                opacity="0.4"
              />
            );
          })
        )}

        {/* Visible seams (deconstruction) */}
        {Array.from({ length: 16 }).map((_, i) => {
          const x = -280 + i * 35;
          return (
            <line
              key={`v-${i}`}
              x1={x}
              y1="-320"
              x2={x}
              y2="320"
              stroke="#D0D0D0"
              strokeWidth="1"
              strokeDasharray="8 8"
              opacity="0.5"
            />
          );
        })}
        
        {Array.from({ length: 22 }).map((_, i) => {
          const y = -320 + i * 29;
          return (
            <line
              key={`h-${i}`}
              x1="-280"
              y1={y}
              x2="280"
              y2={y}
              stroke="#D0D0D0"
              strokeWidth="1"
              strokeDasharray="8 8"
              opacity="0.5"
            />
          );
        })}

        {/* Anonymity circles (white-on-white) */}
        {Array.from({ length: 18 }).map((_, i) => {
          const r = 30 + i * 14;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#E0E0E0"
              strokeWidth="2"
              opacity={0.4 - i * 0.018}
            />
          );
        })}

        {/* Traceable design nodes (numbered tags inspiration) */}
        {[0, 51.43, 102.86, 154.29, 205.71, 257.14, 308.57].map((angle, i) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          
          return (
            <g key={angle}>
              <rect
                x={Math.cos(rad) * r - 16}
                y={Math.sin(rad) * r - 16}
                width="32"
                height="32"
                fill={brand.white}
                stroke="#B0B0B0"
                strokeWidth="2"
                opacity="0.7"
              />
              <text
                x={Math.cos(rad) * r}
                y={Math.sin(rad) * r + 5}
                textAnchor="middle"
                fontFamily="monospace"
                fontSize="12"
                fill="#888"
              >
                {i}
              </text>
            </g>
          );
        })}

        {/* Central transparent frame */}
        <rect x="-80" y="-80" width="160" height="160" fill="none" stroke="#C0C0C0" strokeWidth="3" opacity="0.6" />
        <rect x="-70" y="-70" width="140" height="140" fill="none" stroke="#D8D8D8" strokeWidth="1" opacity="0.5" />
        <rect x="-60" y="-60" width="120" height="120" fill="none" stroke="#E8E8E8" strokeWidth="1" opacity="0.4" />

        {/* Deconstructed corner marks */}
        {[
          { x: -80, y: -80 },
          { x: 80, y: -80 },
          { x: -80, y: 80 },
          { x: 80, y: 80 },
        ].map((corner, i) => (
          <g key={i}>
            <line
              x1={corner.x - 15}
              y1={corner.y}
              x2={corner.x + 15}
              y2={corner.y}
              stroke="#A0A0A0"
              strokeWidth="2"
              opacity="0.6"
            />
            <line
              x1={corner.x}
              y1={corner.y - 15}
              x2={corner.x}
              y2={corner.y + 15}
              stroke="#A0A0A0"
              strokeWidth="2"
              opacity="0.6"
            />
          </g>
        ))}
      </g>

      {/* Margiela text */}
      <text x="397" y="1020" textAnchor="middle" fontFamily="monospace" fontSize="10" fill="#888" opacity="0.7">
        LOGIQUE DE DÉCONSTRUCTION
      </text>
    </g>
  );
}
